import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { CountableLinkSummary } from 'src/app/models/latest-aggregate-amounts.model'
import {
  getYoutubeChannelSubscribers,
  getLoading,
} from 'src/app/selectors/latest-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByYoutubeSubscriber,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-youtube-channel-subscribers-count',
    templateUrl: './aggregated-amounts-youtube-channel-subscribers-count.component.html',
    styleUrls: ['./aggregated-amounts-youtube-channel-subscribers-count.component.scss'],
    standalone: false
})
export class AggregatedAmountsYoutubeChannelSubscribersCountComponent implements OnInit {
  youtubeChannelSubscribersCountModel$: Observable<CountableLinkSummary>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.youtubeChannelSubscribersCountModel$ = this.store.select(getYoutubeChannelSubscribers)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByYoutubeSubscriber)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
